import { createAction, props } from '@ngrx/store';

export const getFilters   = createAction('[UI Component] Get Filters');
export const unSetProducts   = createAction('[UI Component] Clear Products');
export const setProducts   = createAction(
  '[UI Component] Set Products',
  props<{ items: Array<any> }>()
);
